// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9e56771","453":"06aa1ba6","732":"06efdc21","977":"11457157"}[chunkId] + ".chunk.js";
};